module.exports = __webpack_public_path__ + "media/images/category_icons/tv_shows-b54f08b8ca84fdc24781fdbee09013cc.svg";